import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles/index";
import Drawer from "@material-ui/core/Drawer/index";
import Divider from "@material-ui/core/Divider/index";
import CloseIcon from "@material-ui/icons/Close";
import Card from "@material-ui/core/Card/index";
import CardHeader from "@material-ui/core/CardHeader/index";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Alert } from "react-bootstrap";
import { FcMultipleDevices } from "react-icons/fc";
import { TbCalendarTime } from "react-icons/tb";
import { AiOutlineFieldNumber } from "react-icons/ai";
import { GrDirections } from "react-icons/gr";
import { BiLocationPlus } from "react-icons/bi";
import { FaBarcode } from "react-icons/fa";

const useStyles = makeStyles({
  list: {
    width: 400,
    height: "100vh",
  },
  card: {
    margin: "30px",
  },
  pointer: {
    cursor: "pointer",
  },
  progresRoot: {
    width: "100%",
    padding: "32px 16px",
  },
  progress: {
    margin: "auto",
    display: "block",
    color: "#231B88",
  },
});

export default function View(props) {
  const { open, onClose, onDeviceChoose, chooseDeviceId } = props;
  const [device, setDevice] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { name, appointment, cardCount, direction, employeeCount, fingerCount, ipAddress, model, modelId, serialNumber, type } = device;

  useEffect(() => {
    setIsLoading(true);
    onDeviceChoose(chooseDeviceId)
      .then((res) => {
        setDevice(res.data);
        setIsLoading(false);
        setIsError(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setIsError(true);
      });
  }, [chooseDeviceId, onDeviceChoose]);

  const classes = useStyles();


  const sideList = (side) => (
    <div className={classes.list} role="presentation">
      <div className="col-12 d-flex align-items-center justify-content-between py-4">
        <h1 className="h3 mb-0">Qurğu detalları</h1>
        <CloseIcon className={classes.pointer} onClick={onClose} />
      </div>
      <Divider className="bg-dark" />

      {isLoading ? (
        <div className={classes.progresRoot}>
          <CircularProgress className={classes.progress} />
        </div>
      ) : !isLoading && !isError ? (
        <div className="drawer-body">
          <Card className={classes.card}>
            <CardHeader
              title="Ümumi informasiya"
              className="bg-secondary text-dark h6 p-3"
              disableTypography
            />
            <CardHeader
              avatar={

                <FcMultipleDevices className="icon-primary" />
              }
              title={name}
              subheader="Qurğunun adı"
              className="p-3"
            />
            <CardHeader
              avatar={

                <TbCalendarTime className="icon-primary" />
              }
              title={appointment}
              subheader="Təyinat"
              className="p-3"
            />
            <CardHeader
              avatar={

                <AiOutlineFieldNumber className="icon-primary" />
              }
              title={cardCount}
              subheader="Qurğuya bağlı kart sayı"
              className="p-3"
            />
            <CardHeader
              avatar={

                <GrDirections className="icon-primary" />
              }
              title={direction}
              subheader="İstiqamət"
              className="p-3"
            />
            <CardHeader
              avatar={

                <AiOutlineFieldNumber className="icon-primary" />
              }
              title={employeeCount}
              subheader="Qurğuya bağlı əməkdaş sayı  "
              className="p-3"
            />
            <CardHeader
              avatar={

                <AiOutlineFieldNumber className="icon-primary" />
              }
              title={fingerCount}
              subheader="Qurğuya bağlı barmaq izi sayı"
              className="p-3"
            />
            <CardHeader
              avatar={

                <BiLocationPlus className="icon-primary" />
              }
              title={ipAddress}
              subheader="IP"
              className="p-3"
            />
            <CardHeader
              avatar={

                <FcMultipleDevices className="icon-primary" />
              }
              title={model}
              subheader="Qurğu modeli "
              className="p-3"
            />
            <CardHeader
              avatar={

                <FaBarcode className="icon-primary" />
              }
              title={serialNumber}
              subheader="Seriya nömrəsi"
              className="p-3"
            />
            <CardHeader
              avatar={

                <FcMultipleDevices className="icon-primary" />
              }
              title={type}
              subheader="Qurğu tipi"
              className="p-3"
            />
          </Card>
        </div>
      ) : (
        <div className="p-5">
          <Alert variant="info">Xəta baş verdi.</Alert>
        </div>
      )}
    </div>
  );

  return (
    <Drawer
      open={open}
      onClose={onClose}
      anchor="right"
      className="drawer--fixed"
    >
      {sideList("right")}
    </Drawer>
  );
}
